import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';
import { LinkButton } from '../LinkButton/wrappers';

export const Head = styled.div`
  ${theme.screens.Md} {
    font-size: 1.125rem;
  }
`;

export const Caption = styled.div`
  margin: ${size(0.5)} 0;
  color: ${theme.colors.text.alt};

  ${theme.screens.LtMd} {
    font-size: 0.875rem;
  }
`;

export const Action = styled(LinkButton)`
  font-size: 0.875rem;

  ${theme.screens.Md} {
    font-size: 1rem;
  }
`;
